import Footer from 'src/components/UCA/Footer';
import Header from 'src/components/UCA/Header';
import List from 'src/components/UCA/List';
import ListItem from 'src/components/UCA/ListItem';
import SectionPage from 'src/components/UCA/SectionPage';
import { FOOTER_DETAILS, HEADER_DETAILS } from 'src/data/PropertyTaxDueDate/constant';

export default function PropertyTaxDueDate() {
  return (
    <SectionPage>
      <Header {...HEADER_DETAILS} />
      <div className="list-none p-0 px-10 pt-4">
        <List prefix="1">
          <ListItem prefix="a">
            Except as provided in Subsection (1)(b) and subject to Subsections (1)(c) and (d), all
            property taxes, unless otherwise specifically provided for under Section 59-2-1332, or
            other law, and any tax notice charges, are due on November 30 of each year following the
            date of levy.
          </ListItem>
          <ListItem prefix="b">
            If November 30 falls on a Saturday, Sunday, or holiday:
            <List level="1">
              <ListItem prefix="i">
                the date of the next following day that is not a Saturday, Sunday, or holiday shall
                be substituted in Subsection (1)(a) and Subsection 59-2-1332(1) for November 30; and
              </ListItem>
              <ListItem prefix="ii">
                the date of the day occurring 30 days after the date under Subsection (1)(b)(i)
                shall be substituted in Subsection 59-2-1332(1) for December 30.
              </ListItem>
            </List>
          </ListItem>
          <ListItem prefix="c">
            If a property tax is paid or postmarked after the due date described in this Subsection
            (1) the property tax is delinquent.
          </ListItem>
          <ListItem prefix="d">
            A county treasurer or other public official, public entity, or public employee may not
            require the payment of a property tax before the due date described in this Subsection
            (1).
          </ListItem>
        </List>
        <List prefix="2">
          <ListItem prefix="a">
            Except as provided in Subsections (2)(e) and (f), for each parcel, all delinquent taxes
            and tax notice charges on each separately assessed parcel are subject to a penalty of
            2.5% of the amount of the delinquent taxes and tax notice charges or $10, whichever is
            greater.
          </ListItem>
          <ListItem prefix="b">
            Unless the delinquent taxes and tax notice charges, together with the penalty, are paid
            on or before January 31, the amount of taxes and tax notice charges and penalty shall
            bear interest on a per annum basis from the January 1 immediately following the
            delinquency date.
          </ListItem>
          <ListItem prefix="c">
            Except as provided in Subsection (2)(d), for purposes of Subsection (2)(b), the interest
            rate is equal to the sum of:
            <List level="1">
              <ListItem prefix="i">6%; and</ListItem>
              <ListItem prefix="ii">
                the federal funds rate target:
                <List level="2">
                  <ListItem prefix="A">
                    established by the Federal Open Markets Committee; and
                  </ListItem>
                  <ListItem prefix="B">
                    that exists on the January 1 immediately following the date of delinquency.
                  </ListItem>
                </List>
              </ListItem>
            </List>
          </ListItem>
          <ListItem prefix="d">
            The interest rate described in Subsection (2)(c) may not be:
            <List level="1">
              <ListItem prefix="i">less than 7%; or</ListItem>
              <ListItem prefix="ii">more than 10%.</ListItem>
            </List>
          </ListItem>
          <ListItem prefix="e">
            The penalty described in Subsection (2)(a) is 1% of the amount of the delinquent taxes
            and tax notice charges or $10, whichever is greater, if all delinquent taxes, all tax
            notice charges, and the penalty are paid on or before the January 31 immediately
            following the delinquency date.
          </ListItem>
          <ListItem prefix="f">
            This section does not apply to the costs, charges, and interest rate accruing on any tax
            notice charge related to an assessment assessed in accordance with:
            <List level="1">
              <ListItem prefix="i">Title 11, Chapter 42, Assessment Area Act; or</ListItem>
              <ListItem prefix="ii">
                Title 11, Chapter 42a, Commercial Property Assessed Clean Energy Act.
              </ListItem>
            </List>
          </ListItem>
        </List>
        <List prefix="3">
          <ListItem prefix="a">
            If the delinquency exceeds one year, the amount of taxes, tax notice charges, and
            penalties for that year and all succeeding years shall bear interest until settled in
            full through redemption or tax sale.
          </ListItem>
          <ListItem prefix="b">
            The interest rate to be applied shall be calculated for each year as established under
            Subsection (2) and shall apply on each individual year&apos;s delinquency until paid.
          </ListItem>
        </List>
        <List prefix="4">
          The county treasurer may accept and credit on account against taxes and tax notice charges
          becoming due during the current year, at any time before or after the tax rates are
          adopted, but not subsequent to the date of delinquency, either:
          <ListItem prefix="a">payments in amounts of not less than $10; or</ListItem>
          <ListItem prefix="b">the full amount of the unpaid tax and tax notice charges.</ListItem>
        </List>
        <List prefix="5">
          <ListItem prefix="a">
            At any time before the county treasurer provides the tax notice described in Section
            59-2-1317, the county treasurer may refund amounts accepted and credited on account
            against taxes and tax notice charges becoming due during the current year.
          </ListItem>
          <ListItem prefix="b">
            Upon recommendation by the county treasurer, the county legislative body shall adopt
            rules or ordinances to implement the provisions of this Subsection (5).
          </ListItem>
        </List>
      </div>
      <Footer {...FOOTER_DETAILS} />
    </SectionPage>
  );
}
